<form (ngSubmit)="submitFiles(formGroup.value)" autocomplete="off" novalidate [formGroup]="formGroup">
  <div class="container-fluid ps-0 pe-0">
    <div class="row">
      <div class="col-12">
        <strong>Upload the files you would like to annotate</strong>
      </div>
    </div>
    <div class="row">
      <div class="col-9">
        <mat-form-field class="example-chip-list">
          <mat-chip-grid #filesList>
            <mat-chip-row *ngFor="let file of files"
                      [selectable]="selectable"
                      [removable]="removable"
                      (removed)="removeFile(file)">
              {{file.filename}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip-row>
            <input placeholder="Files"
                   [matChipInputFor]="filesList"
                   [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                   [matChipInputAddOnBlur]="addOnBlur" readonly>
            <input type="file" id="file" formControlName="file" (change)="onFileChange($event)" style="display: none;" multiple>
          </mat-chip-grid>
        </mat-form-field>
      </div>
      <div class="col-3 text-end">
        <button mat-raised-button class="mt-2" type="button" color="primary" (click)="openFileBrowser($event)">Add</button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-end">
        <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
        <button mat-raised-button type="submit" color="primary" class="btn-upload" *ngIf="!loading" cdkFocusInitial>Upload</button>
      </div>
    </div>
  </div>
</form>
